import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { DentalSupplierAddresses } from '../models/dental-supplier-addresses';
import { omit } from 'lodash';

const addDentalSupplierAddressesMutation = gql`mutation addDentalSupplierAddresses($dental_supplier_addressees: dental_supplier_addresses_insert_input!){
  insert_dental_supplier_addresses_one(object: $dental_supplier_addressees){
    id
  }
}`;

const addDentalProfessionalAddressesMutation = gql`mutation addDentalProfessionalAddresses($dental_professional_addressees: dental_professional_addresses_insert_input!){
  insert_dental_professional_addresses_one(object: $dental_professional_addressees){
    id
  }
}`;

const addDentalPracticeAddressesMutation = gql`mutation addDentalPracticeAddresses($dental_practice_addressees: dental_practice_addresses_insert_input!){
  insert_dental_practice_addresses_one(object: $dental_practice_addressees){
    id
  }
}`;

@Injectable({
  providedIn: 'root'
})
export class AddDentalSupplierAddressesService {

/* ------------------------------- Constructor ------------------------------ */

  constructor(private apollo: Apollo) { }

/* ---------------------- Add Dental Supplier Addresses --------------------- */

  addDentalSupplierAddresses(dental_supplier_addressees: DentalSupplierAddresses){
    return this.apollo.use('external').mutate({
      mutation: addDentalSupplierAddressesMutation,
      variables: {
        dental_supplier_addressees: omit(dental_supplier_addressees, ['id'])
      }
    }).toPromise();
  }

  /* ---------------------- Add Dental Professional Addresses --------------------- */

  addDentalProfessionalAddresses(dental_professional_addressees: any){
    return this.apollo.use('external').mutate({
      mutation: addDentalProfessionalAddressesMutation,
      variables: {
        dental_professional_addressees: omit(dental_professional_addressees, ['id'])
      }
    }).toPromise();
  }

    /* ---------------------- Add Dental Professional Addresses --------------------- */

    addDentalPracticeAddresses(dental_practice_addressees: any){
      return this.apollo.use('external').mutate({
        mutation: addDentalPracticeAddressesMutation,
        variables: {
          dental_practice_addressees: omit(dental_practice_addressees, ['id'])
        }
      }).toPromise();
    }
}
